/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PhysicalCountDiscrepancyDto } from './PhysicalCountDiscrepancyDto';
import type { PhysicalCountDuplicateDto } from './PhysicalCountDuplicateDto';
export type PhysicalCountSessionResponseDto = {
    id: number;
    code: string;
    status: PhysicalCountSessionResponseDto.status;
    locationId: number;
    locationName: string;
    sessionDate: string;
    comparedAt?: string;
    expectedCount: number;
    actualCount: number;
    successCount: number;
    missingCount: number;
    excessCount: number;
    duplicateCount: number;
    scannedNotAvailableCount: number;
    createdBy?: string;
    createdAt: string;
    discrepancies?: Array<PhysicalCountDiscrepancyDto>;
    duplicates?: Array<PhysicalCountDuplicateDto>;
};
export namespace PhysicalCountSessionResponseDto {
    export enum status {
        OPEN = 'open',
        FINALIZED = 'finalized',
    }
}

